import axios from "axios";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const headers = useRequestHeaders(["cookie", "authorization"]);

  const instance = axios.create({
    baseURL: config.public.apiBaseUrl,
    headers,
  });

  return {
    provide: {
      axios: instance,
    },
  };
});
